import * as d3 from 'd3'
import LZString from 'lz-string'

import {activateLicenseToken, app_name_opensankeyplus, app_name_sankeysuite} from '../LicenseCheckIn/LicenseFunctions'

// Activate license Tokens if licenses are valid
export async function activateLicensesTokens(
    setOpenSankeyPlus:(token:boolean)=>void,
    setSankeySuite:(token:boolean)=>void,
    setSankeyDev:(token:boolean)=>void)
{
    // Check AFM license
    activateLicenseToken(
        app_name_sankeysuite,
        "/user_infos/license_sankeysuite",
        setSankeySuite
    )
    // Check OpenSankey+ licence
    activateLicenseToken(
        app_name_opensankeyplus,
        "/user_infos/license_opensankeyplus",
        setOpenSankeyPlus
    )
    // Check if has dev acc
    fetch("/user_infos/is_developer",)
    .then(response => {
      if ( response.ok ) {
        return response.json()
      } else {
        return Promise.reject( response )
      }
    }).then(data => {
        setSankeyDev(data.is_dev)
        if(data.is_dev){
            sessionStorage.setItem('SankeyDev', LZString.compress(JSON.stringify(true)))
            // console.log('SankeyDev', " activé")
        }
    
    })
}

const getName=()=>{
    const path = window.location.origin
    const url = path + '/user_infos'
      fetch(url)
      .then(response => {
        if ( response.ok ) {
          return response.json()
        } else {
          return Promise.reject( response )
        }
      }).then(data => {
        console.log(data)
      })
}

// Check if login if valid
export async function loginUser(
    t:(msg:string)=>string,
    credentials:{
      email: string;
      password: string;
      remember:boolean;},
    setToken:(token:boolean)=>void,
    setOpenSankeyPlus:(token:boolean)=>void,
    setSankeySuite:(token:boolean)=>void,
    setSankeyDev:(token:boolean)=>void,
    navigate:(route:string)=>void,
    set_name_user:(s:string)=>void
    
    )
    
{
    // Remove all errors from screen
    d3.select('.LogError').selectAll('*').remove()
    // Fetch Login
    const path = window.location.origin
    const url = path + '/auth/login'
    return fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    })
    .then( response => {
        if ( response.ok ) {
            return response.json()
        } else {
            d3.select('.LogError').append('p').text(t('Login.err_appel_serveur'))
            return Promise.reject( response )
        }
    })
    .then(data =>{
        // console.log(data)
        if(data['is_connected']){
            setToken(true)
            sessionStorage.setItem('token', LZString.compress(JSON.stringify(true)))
            activateLicensesTokens(setOpenSankeyPlus, setSankeySuite, setSankeyDev)

            const path = window.location.origin
            const url = path + '/user_infos'
            fetch(url)
            .then(response => {
              if ( response.ok ) {
                return response.json()
              } else {
                return Promise.reject( response )
              }
            }).then(data => {
              // User data
              if(data.name){
                set_name_user(data.name)
              }
            })

            navigate('/')
        } else {
            d3.select('.LogError').append('p').text(t('Login.err_login'))
        }
    })
}

// Properly logOut user
export async function logOutUser(
    logOut:()=>void)
{
    // Set all tokens to false
    logOut()
    // LogOut on server
    const path = window.location.origin
    const url = path + '/auth/logout'
    return fetch(url)
}

  //Logout
  export  const loginOut=(unsetTokens:()=>void,returnToApp:()=>void)=>{
    sessionStorage.removeItem('token')
    sessionStorage.removeItem(app_name_opensankeyplus)
    sessionStorage.removeItem(app_name_sankeysuite)
    sessionStorage.removeItem('SankeyDev')
    logOutUser(unsetTokens)
    returnToApp()
  }